import type { ActionStatus } from "../types";

const STYLES: Record<ActionStatus, { bg: string; fg: string; label: string }> = {
  OPEN: { bg: "hsl(210,55%,92%)", fg: "hsl(210,100%,28%)", label: "Open" },
  IN_PROGRESS: {
    bg: "hsl(38,90%,92%)",
    fg: "hsl(32,90%,38%)",
    label: "In Progress",
  },
  COMPLETED: {
    bg: "hsl(142,55%,92%)",
    fg: "hsl(142,72%,28%)",
    label: "Completed",
  },
  CANCELLED: {
    bg: "hsl(210,16%,93%)",
    fg: "hsl(215,16%,40%)",
    label: "Cancelled",
  },
};

export function ActionStatusBadge({ status }: { status: ActionStatus }) {
  const s = STYLES[status];
  return (
    <span
      className="inline-flex items-center rounded-full px-2 py-0.5 text-[11px] font-medium"
      style={{ background: s.bg, color: s.fg }}
    >
      {s.label}
    </span>
  );
}
